const settings = [
  { label: 'Default Prefered Language', name: 'language_id', type: 'lookup', endpoint: '/api/admin/crm/languages', valueKey: 'id', textKey: 'text', defaultValue: 12 }
]

export default settings
